import { useModalHandlerContext } from "../contexts/modal-handler-context";


export default function useOpenModal(){
    const { openModal } = useModalHandlerContext();
    return openModal;
}